"use client";

import { c as _c } from "react/compiler-runtime";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserStatsRow from "../../utils/stats/UserStatsRow";
const SAFE_ROUTE_SEGMENT_PATTERN = /^[a-zA-Z0-9._-]+$/;
function sanitizeRouteSegment(value: string): string | null {
  if (!value) {
    return null;
  }
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }
  const normalizedValue = trimmedValue.toLowerCase();
  if (!SAFE_ROUTE_SEGMENT_PATTERN.test(normalizedValue)) {
    return null;
  }
  return encodeURIComponent(normalizedValue);
}
export default function UserPageHeaderStats(t0) {
  const $ = _c(11);
  const {
    profile,
    handleOrWallet,
    followersCount
  } = t0;
  let t1;
  if ($[0] !== handleOrWallet) {
    t1 = sanitizeRouteSegment(handleOrWallet);
    $[0] = handleOrWallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const routeHandle = t1;
  if (!routeHandle) {
    return null;
  }
  let t2;
  if ($[2] !== followersCount || $[3] !== profile.cic || $[4] !== profile.rep || $[5] !== profile.tdh || $[6] !== profile.tdh_rate || $[7] !== profile.xtdh || $[8] !== profile.xtdh_rate || $[9] !== routeHandle) {
    t2 = <div className="tw-mt-3"><UserStatsRow handle={routeHandle} tdh={profile.tdh} tdh_rate={profile.tdh_rate} xtdh={profile.xtdh} xtdh_rate={profile.xtdh_rate} rep={profile.rep} cic={profile.cic} followersCount={followersCount} /></div>;
    $[2] = followersCount;
    $[3] = profile.cic;
    $[4] = profile.rep;
    $[5] = profile.tdh;
    $[6] = profile.tdh_rate;
    $[7] = profile.xtdh;
    $[8] = profile.xtdh_rate;
    $[9] = routeHandle;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}